import AnalyticsService, { AnalyticsEnum } from '@picsart/rc/services/analytics';
import type { IAnalyticsEvent } from '@picsart/rc/types';

class Analytics {
  constructor() {
    this.sendEventNonInteraction = this.sendEventNonInteraction.bind(this);
    this.pushDataLayer = this.pushDataLayer.bind(this);
    this.sendEvent = this.sendEvent.bind(this);
    this.pageView = this.pageView.bind(this);
  }

  private readonly AnalyticsService = AnalyticsService;

  public init() {
    this.AnalyticsService.init(
      process.env.NEXT_PUBLIC_GTM_ID,
      'tech-seo',
      'dataLayer',
      AnalyticsEnum.gtag,
      3000,
    );
  }

  private sendEventNonInteraction(eventName: string, data: object) {
    this.AnalyticsService.sendEventNonInteraction(eventName, data);
  }

  private sendEvent(eventName: string, data: object) {
    this.AnalyticsService.sendEvent(eventName, data);
  }

  public pushDataLayer(dataLayer: IAnalyticsEvent | object) {
    this.AnalyticsService.pushDataLayer(dataLayer);
  }

  public pageView(page: string) {
    this.AnalyticsService.pageView(page);
  }

  public fireEvent(eventName: string, data: object, interaction = true) {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const send = interaction ? this.sendEvent : this.sendEventNonInteraction;
    send(eventName, data);
  }

  public firePageOpen(screen: string, data: object = {}) {
    this.fireEvent(
      'page_open',
      {
        screen_name: screen,
        source: true,
        ...data,
      },
      false,
    );
  }
}

export default new Analytics();
